<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <button class="btn btn-primary w-100" id="pick-avatar">
      Bild hochladen
    </button>
    <avatar-cropper
      ref="avatar-cropper"
      @uploaded="uploaded"
      @changed="filePicked"
      @error="addError"
      trigger="#pick-avatar"
      :labels="{ submit: 'Hochladen', cancel: 'Abrechen' }"
      :upload-headers="headers"
      :outputOptions="{}"
      :upload-handler="uploadHandler"
    />
    <div
      v-if="hasErrors"
      v-for="error in fails"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import { CSRFToken } from '@/communication';
import AvatarCropper from 'vue-avatar-cropper';

export default {
  components: {
    AvatarCropper,
  },
  props: {
    url: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      allowed_ext: ["png", "gif", "jpg", "jpeg", "bmp", "x-icon"],
      validImage: false,
      selectedType: null,
      fails: []
    }
  },
  methods: {
    filePicked(resp) {
      this.selectedType = resp.type;
      this.fails = [];
      const ext = resp.name.split(".").pop().toLowerCase();
      if (!(this.allowed_ext.indexOf(ext) > -1)) {
        this.validImage = false;
      } else {
        this.validImage = true;
      }
    },
    uploaded(resp) {
      this.$emit('uploaded', resp);
    },
    addError(error) {
      this.fails.push(error);
    },
    uploadHandler() {
      this.$refs['avatar-cropper'].cropper.getCroppedCanvas(this.outputOptions).toBlob(
        blob => {
          const formData = new FormData();
          formData.append('file', blob);
          let successMessage = 'Dein Medium wurde erfolgreich hochgeladen und wird geprüft.';
          if (this.$store.getters["user/meHasRole"]("admin")) {
            successMessage = 'Dein Medium wurde erfolgreich hochgeladen';
          }

          this.$store.dispatch('uploadProgress/uploadMedia', {
            url: this.url,
            data: formData,
            meta: [
              this.selectedType,
              blob.size
            ],
            successMessage: successMessage
          });
        }
      );
    }
  },
  computed: {
    headers() {
      return { "X-CSRF-TOKEN": CSRFToken() };
    },
    hasErrors() {
      return this.fails.length !== 0;
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs['avatar-cropper'].cropper;
      },
      (val) => {
        if (val && !this.validImage) {
          this.$refs['avatar-cropper'].destroy();
          this.addError('Diese Datei kann nicht hochgeladen werden');
        }
      }
    );

    this.$watch(
      () => {
        return this.$refs['avatar-cropper'].dataUrl;
      },
      (val) => {
        if (val && !this.validImage && !val.startsWith('data:image/')) {
          if (this.$refs['avatar-cropper'].cropper) {
            this.$refs['avatar-cropper'].destroy();
          } else {
            this.$refs['avatar-cropper'].$refs.input.value = '';
            this.$refs['avatar-cropper'].dataUrl = undefined;
          }
          this.addError('Diese Datei kann nicht hochgeladen werden');
        }
      }
    );
  }
}
</script>
